import { call, put, takeLatest } from 'redux-saga/effects'
import {
  getListAddWhiteListsSuccess,
  getListAddWhiteListsFailed,
  GET_LIST_ADD_WHITELIST_START,
} from '../../actions/whiteList'
import { api } from '~/services/api'

/**
 * get list add whitelist api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getListAddWhiteListsApi = (props) => {
  var uri = `/sponsor-tournament-whitelist/users`
  return api.get(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetAddWhiteLists(action) {
  try {
    const response = yield call(getListAddWhiteListsApi, action?.payload)
    yield put(getListAddWhiteListsSuccess(response?.data))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response)
    }
  } catch (error) {
    yield put(getListAddWhiteListsFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get list add whitelist
 */
export default function* watchGetAddWhiteLists() {
  yield takeLatest(GET_LIST_ADD_WHITELIST_START, doGetAddWhiteLists)
}
